<ng-container *ngIf="!loading">
    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-panel header="{{'VIGENCIADEDATOS.LBL_VERDOCUMENTO' | translate}}">
            <div class="grid form-group">
                <div class="col-12 md:col-3 lg:col-3">
                    <div class="div-form">
                        <label for="codigo">{{"VIGENCIADEDATOS.LBL_CODIGO" | translate}}</label>
                        <label class="falso-combo-texto">{{ admDocument.codigo }}</label>
                    </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3">
                    <div class="div-form">
                        <label for="nombre">{{"VIGENCIADEDATOS.LBL_NOMBRE" | translate}}</label>
                        <label class="falso-combo-texto">{{ admDocument.nombre }}</label>
                    </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3">
                    <div class="div-form">
                        <label for="idTipoVigencia">{{"VIGENCIADEDATOS.LBL_TIPOVIGENCIA" | translate}}</label>
                        <label class="falso-combo-texto">{{ labelTypeValidity(admDocument.idTipoVigencia) }}</label>
                    </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3" *ngIf="admDocument.duracionVigencia">
                    <div class="div-form">
                        <label for="duracionVigencia">{{"VIGENCIADEDATOS.LBL_VIGENCIA" | translate}}</label>
                        <label class="falso-combo-texto">{{ admDocument.duracionVigencia }}</label>
                    </div>
                </div>
            </div>
            <div class="grid form-group">
                <div class="col-12 md:col-6 lg:col-6">
                    <div class="div-form">
                        <label for="descripcion">{{"VIGENCIADEDATOS.LBL_DESCRIPCION" | translate}}</label>
                        <label class="falso-combo-texto">{{ admDocument.descripcion }}</label>
                    </div>
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                    <div class="check-container">
                        <p-checkbox
                            label="{{ 'VIGENCIADEDATOS.TERCERO' | translate}}"
                            [binary]="true"
                            [(ngModel)]="admDocument.indicadorTercero"
                            [disabled]="true"
                        ></p-checkbox>
                        <p-checkbox
                            label="{{ 'VIGENCIADEDATOS.LBL_SOLICITARCLIENTE' | translate}}"
                            [binary]="true"
                            [(ngModel)]="admDocument.indicadorSolicitarCliente"
                            [disabled]="true"
                        ></p-checkbox>
                        <p-checkbox
                            label="{{ 'VIGENCIADEDATOS.LBL_HABILITADO' | translate}}"
                            [binary]="true"
                            [(ngModel)]="admDocument.indicadorHabilitado"
                            [disabled]="true"
                        ></p-checkbox>
                        </div>
                    </div>
                </div>
            <div class="grid form-footer-buttons">
                <div class="form-group col-12">
                    <button icon="fa fa-arrow-left" 
                            label="{{'BTN_REGRESAR' | translate }}" 
                            type="button"
                            pButton 
                            class="p-button-text"
                            style="width: auto; min-width: 120px;"
                            (click)="goBack()">
                    </button>
                </div>
            </div>
          </p-panel>
        </div>
    </div>
</ng-container>
<app-loading *ngIf="loading"></app-loading>
